import { render, staticRenderFns } from "./chain-shop-list.vue?vue&type=template&id=becaa500&scoped=true&"
import script from "./chain-shop-list.vue?vue&type=script&lang=js&"
export * from "./chain-shop-list.vue?vue&type=script&lang=js&"
import style0 from "./chain-shop-list.vue?vue&type=style&index=0&id=becaa500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becaa500",
  null
  
)

export default component.exports